<script lang="ts">
  import { onMount } from 'svelte';
  import Navigation from './components/Navigation.svelte';
  import Hero from './components/Hero.svelte';
  import Pricing from './components/Pricing.svelte';
  import CTA from './components/CTA.svelte';
  import OrderDetail from './routes/OrderDetail.svelte';

  let currentRoute: string = 'home';
  let routeParams: any = {};

  function updateRoute() {
    const path = window.location.pathname;
    const segments = path.split('/').filter(Boolean);

    if (segments.length === 0) {
      currentRoute = 'home';
      routeParams = {};
    } else if (segments[0] === 'orders' && segments.length === 2) {
      currentRoute = 'order-detail';
      routeParams = { accessToken: segments[1] };
    } else {
      currentRoute = 'home';
      routeParams = {};
    }
  }

  onMount(() => {
    updateRoute();

    // Handle browser back/forward buttons
    window.addEventListener('popstate', updateRoute);

    return () => {
      window.removeEventListener('popstate', updateRoute);
    };
  });
</script>

{#if currentRoute === 'home'}
  <div class="min-h-screen bg-black">
    <Navigation />
    <Hero />
    <Pricing />
    <CTA />
  </div>
{:else if currentRoute === 'order-detail'}
  <OrderDetail accessToken={routeParams.accessToken} />
{/if}
